import { FocusDto } from '../../coaching-base/general';
import { ObservationSummaryContainerView } from '../../coaching-detail';

export interface ObservationReviewState {
    observations?: ObservationSummaryContainerView[]; // these are actually focus containers
    observationIndex?: number;
    selectedObservation?: ObservationSummaryContainerView;
    inReview?: boolean;
    focus?: FocusDto;
}

export const defaultState = (): ObservationReviewState => ({
    observationIndex: 0,
    inReview: true,
});
